/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomersByOrganizationQueryVariables = Types.Exact<{
  organizationId: Types.Scalars['ID'];
}>;


export type GetCustomersByOrganizationQuery = { __typename?: 'Query', customersByOrganization: Array<{ __typename?: 'Customer', id: string, name: string, handle: string }> };


export const GetCustomersByOrganizationDocument = gql`
    query GetCustomersByOrganization($organizationId: ID!) {
  customersByOrganization(organizationId: $organizationId) {
    id
    name
    handle
  }
}
    `;

/**
 * __useGetCustomersByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetCustomersByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCustomersByOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomersByOrganizationQuery, GetCustomersByOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomersByOrganizationQuery, GetCustomersByOrganizationQueryVariables>(GetCustomersByOrganizationDocument, options);
      }
export function useGetCustomersByOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomersByOrganizationQuery, GetCustomersByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomersByOrganizationQuery, GetCustomersByOrganizationQueryVariables>(GetCustomersByOrganizationDocument, options);
        }
export type GetCustomersByOrganizationQueryHookResult = ReturnType<typeof useGetCustomersByOrganizationQuery>;
export type GetCustomersByOrganizationLazyQueryHookResult = ReturnType<typeof useGetCustomersByOrganizationLazyQuery>;
export type GetCustomersByOrganizationQueryResult = ApolloReactCommon.QueryResult<GetCustomersByOrganizationQuery, GetCustomersByOrganizationQueryVariables>;